<div class="modal-header" style="padding: 15px !important; border-bottom: 1px solid #e5e5e5;">
    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="closeModal()">&times;</button>
    <h4 class="modal-title wrap-text-in" [innerHTML]="modalData.title"></h4>
</div>

<div class="modal-body">
    <div *ngIf="modalData.action === 'jobProfile'">
        <app-job-profile [jobId]="modalData.jobId" context="requisitionCard" (closeModalCallback)="closeModal()"></app-job-profile>
    </div>
    <div *ngIf="modalData.action === 'jobLeft'">
        <app-job-left
            [jobId]="modalData.jobId"
            (saveCallback)="saveCallback()"
            (cancelCallback)="closeModal()"
            sourceScreen="REQUISITION"
            [formalizeActivityPayload]="modalData.formalizeActivityPayload">
        </app-job-left>
    </div>
    <div *ngIf="modalData.action === 'doNotHire'">
        <app-do-not-hire
            context="requisitionCard"
            [nonJoinedCandidates]="modalData.nonJoinedCandidates"
            [jobId]="modalData.jobId"
            (cancelCallback)="closeModal()"
            (saveCallback)="saveCallback()"
            sourceScreen="REQUISITION"
            [formalizeActivityPayload]="modalData.formalizeActivityPayload">
        </app-do-not-hire>
    </div>
    <div *ngIf="modalData.action === 'clientReview'">
        <app-email-client-review
            context="requisitionCard"
            [clientReviewDetails]="true"
            [jobId]="modalData.jobId"
            (cancelCallback)="closeModal()"
            (saveCallback)="closeModal()">
        </app-email-client-review>
    </div>
</div>
